export const en = {
  welcomeTitle: 'Digital Competence Diagnostic tool',
  welcomeDescription:
    'This tool assists civil society with assessing their digital competence. It is based on the <a href="https://publications.jrc.ec.europa.eu/repository/handle/JRC128415">EU Digital Competence Framework for Citizens</a>, and adapted to the needs of organisations. This diagnostic tool was built by the team and coaches of the Digital Competence course organised by the <a href="https://eapcivilsociety.eu/">Eastern Partnership for Civil Society</a>.',
  welcomeStartSelfAssessment: 'Start Self-Assessment',
  welcomeOr: 'or',
  welcomePickUpWhereYouLeft: 'Pick up where you left off.',
  welcomeEnterCode: 'Enter code',
  welcomeContinue: 'Continue',
  welcomeStartNewSelfAssessment: 'Start a New Self-Assessment',
  categoriesPleaseChoose: 'Please choose a category to start',
  categoriesChooseNext: 'Choose next category',
  categoriesDescriptionFirst:
    'The self-assessment is divided into several key categories. We suggest you start with any category of your preference, as the order in which you go through different categories does not impact the overall results.',
  categoriesDescriptionSecond:
    'The more statements you go through, the more complete and informed results you will get.',
  categoriesStateOfDiversity: 'Digital Competence',
  categoriesSave: 'Save',
  categoriesExport: 'Export PDF',
  categoryInProgress: 'In progress',
  categorySetAsGoal: 'Set as goal',
  categoryRemoveGoal: 'Remove goal',
  categoryAnswered: 'answered',
  categoryBack: 'Back',
  categoryClickOnMaturityLevel:
    'Click on a maturity level to see finished and unanswered statements',
  categoryDoNotApply: 'do not apply',
  notFound: 'Not Found',
  statementPageBack: 'Back',
  statementShowResults: 'Show results',
  aboutSelfDiagnosticTool: 'About the Self-Diagnostic Tool',
  aboutParagraphOne:
    'Assessing digital competence from an organisational perspective is a challenging process. The EU Digital Competence Framework for Citizens is a comprehensive and logical overview of what digital competence means, and it meaingfully categorizes skills, competencies, and attitudes to help individuals assess and grow their competence. However, looking at digital competence from the perspective of a team, an organisation, is a different dimension of competence, for which we felt that the original framework deserved a focused tool.',
  aboutParagraphTwo:
    'This self-diagnostic tool extends the EU digital competence framework into the territory of organisational maturity: what does it mean for an organisation to be digitally competent? the EaP team, together with coaches for their Digital Competence course, translated the framework into organisational maturity areas, so that teams and orgs can reflect on their digital competence from a space of policies, best practices, capacity building, and peer/partner support. The tool is designed with Civil Society in mind, specifically groups from EaP countries (Armenia, Azerbaijan, Belarus, Georgia, Moldova and Ukraine). However, it can be a helpful resource for any team, company, or organisation intent on becoming more intentional about their digital competence progress.',
  aboutWhatHappensNext: 'What happens next?',
  aboutParagraphThree: '',
  aboutParagraphFour:
    'If you are surprised with the results - perhaps it would be an interesting and useful exercise to ask a colleague to fill out the self-assessment tool, so that you can cross-reference and compare your respective results, identifying in the process the causes behind eventual discrepancies. If you are pleased with the results, it might be an excellent opportunity to see in what ways some of your current practices could be further codified, standardized and institutionalized across policies and organisational key processes and practices.',
  aboutParagraphFive: '',
  aboutAcknowledgments: 'Acknowledgments',
  aboutCreativeConsultancyTeams:
    '<strong>Eastern Partnership for Civil Society:</strong> Monica Bucurenciu, Simon Forrester',
  aboutSensemakingLab:
    '<strong>Tool adaptation and lead coach: </strong> Tin Geber - <a href="https://tin.fyi">tin.fyi</a>',
  aboutCIVICUSSupportTeam:
    '<strong>CIVICUS Support Team:</strong> Suhani Bhushan, Oriana Castillo, Emaan Ali',
  aboutDIGNAAdvisoryGroupMembers:
    '<strong>EaP DC coaches:</strong>Denys Andrushchenko (Ukraine), Hovhannes Aghajanyan (Armenia), Nino Gamisonia (Georgia), Roman Gluck (Moldova), Saba Khergiani (Georgia), Nensi Mkrtchyan (Armenia)',
  aboutSpecialThanks:
    'The original version of this diagnostic tool was developed by CIVICUS as part of their Diversity and Inclusion program. <a href="https://diversitytool.civicus.org/">Visit the diversiy tool DIGNA</a> to find more about the tool and its creators.',
  aboutSpecialAppreciation:
    'We also wish to extend special appreciation to <a href="https://lindaraftree.com/">Linda Raftree</a>, whose work on the <a href="https://lindaraftree.com/2019/10/17/a-responsible-data-maturity-model-for-non-profits/">Responsible Data Maturity Model</a> guided our reasoning both in structure and in intent.',
  filtersShowFiltersByArea: 'Show Filters by Area',
  filtersRemoveFiltersByArea: 'Remove Filters by Area',
  goalButtonSetGoalPerCategory: 'Set goal per category',
  goalButtonFinishSettingGoal: 'Finish setting goals',
  saveModalSaveYourProgress: 'Save Your Progress',
  saveModalCopyThisCode:
    'Copy this code and save it somewhere safe. You can come back to your score and continue working on it.',
  saveModalCode: 'Code',
  saveModalCopied: 'Copied.',
  saveModalDone: 'Done',
  navigationAbout: 'About',
  navigationResources: 'Resources',
  navigationTutorial: 'Tutorial',
  navigationLanguages: 'Languages',
  navigationRestartAssessment: 'Restart Assessment',
  statementsProgress: 'Progress:',
  statementsRequired: 'Required:',
  statementsAssessment:
    'The assessment is more precise with every question you answer.',
  statementsHowMuchDoesThis: 'How much does this statement resonate?',
  statementsNotAtAll: 'Not at all',
  statementsSomewhat: 'Somewhat',
  statementsVeryMuch: 'Very much',
  statementsDoesNotApply: 'Doesn’t apply',
  resetModalRestartAssessment: 'Restart Assessment',
  resetModalTitle:
    'Are you sure you want to delete your progress and restart the assessment?',
  resetModalSubtitle:
    'If you think current progress might be useful, consider saving it before restarting the assessment.',
  resetModalCancel: 'No, take me back',
  resetModalConfirm: 'Yes, delete my current progress.',
  exportModalExportPdf: 'Export PDF',
  exportModalDetails:
    'You can optionally add this information to customize your print. It will not be stored on the website.',
  exportModalNameCompiler: 'Name(s) of compiler(s)',
  exportModalNameOrganization: 'Name of organisation',
  exportModalLoading: 'Generating...',
  exportModalDownload: 'Download PDF',
  pdfTitle: 'Digital Competence Self-assessment',
  pdfCompiledBy: 'Compiled by',
  pdfOnBehalfOf: 'On behalf of',
  pdfAssessmentCode: 'Assessment code',
  pdfIntroduction: 'Introduction',
  pdfCategoriesAndStatements: 'Categories and Statements',
  pdfAboutCreativeConsultancyTeams:
    '<strong>Eastern Partnership for Civil Society:</strong> Monica Bucurenciu, Simon Forrester',
  pdfAboutSensemakingLab:
    '<strong>Tool adaptation and lead coach: </strong> Tin Geber - <a href="https://tin.fyi">tin.fyi</a>',
  pdfAboutCIVICUSSupportTeam:
    'The original version of this diagnostic tool was developed by CIVICUS as part of their Diversity and Inclusion program. <a href="https://diversitytool.civicus.org/">Visit the diversiy tool DIGNA</a> to find more about the tool and its creators.',
  pdfAboutDIGNAAdvisoryGroupMembers:
    '<strong>EaP DC coaches:</strong>Denys Andrushchenko (Ukraine), Hovhannes Aghajanyan (Armenia), Nino Gamisonia (Georgia), Roman Gluck (Moldova), Saba Khergiani (Georgia), Nensi Mkrtchyan (Armenia)',
  pdfAboutSpecialAppreciation1:
    'We also wish to extend special appreciation to',
  pdfAboutSpecialAppreciation2: ', whose work on the',
  pdfAboutSpecialAppreciationLink2: 'Responsible Data Maturity Model',
  pdfAboutSpecialAppreciation3:
    'guided our reasoning both in structure and in intent.',
  introTutorial:
    'As you select a category, you will be offered a series of statements. Try to evaluate the statements without overthinking, selecting the ones that best reflect your lived reality in your organisation.',
  resultsUnansweredStatements: 'Unanswered statements',
  resultsIn: 'in',
  resultsFinishedStatements: 'Finished statements',
  howToUsePageTitle: 'How to use',
  howToUseIntro:
    'This is a self-evaluation tool based on the concept of the maturity model, inspired by Linda Raftree’s work on the <a href="https://lindaraftree.com/2019/10/17/a-responsible-data-maturity-model-for-non-profits/">Responsible Data Maturity Model</a>. The maturity model is self-reflective: instead of asking questions, it presents statements that describe a certain level of organisational maturity with regards to a category. The statements have been crafted and assigned to a maturity level:',
  howToUseListA1:
    '<strong>Unaware: </strong> <i>We don’t know what we don’t know</i>',
  howToUseListA2:
    '<strong>Ad-Hoc:</strong> <i>Some team members are skilled, but we do not have org-wide policies or best practices</i>',
  howToUseListA3:
    '<strong>Developing: </strong> <i>We started creating structures, policies, and best practices</i>',
  howToUseListA4:
    '<strong>Mastering: </strong> <i>Our policies and best practices are well designed and successfully implemented</i>',
  howToUseListA5:
    '<strong>Leading: </strong> <i>Peers and partners recognize us as leaders in the space, and come to us for support</i>',
  howToUseAssigningValuesToStatements: 'Assigning values to statements',
  howToUseParagraph1:
    'For each statement, you are asked to express how much that statement resonates with your organisation’s experience:',
  howToUseListB1: 'Not at all',
  howToUseListB2: 'Somewhat',
  howToUseListB3: 'Very Much',
  howToUseListB4: 'Doesn’t apply',
  howToUseParagraph2:
    'There are quite a few statements, so the work of going through all of them is not easy. We did our best to simplify it: you can either choose to go through a random list of statements pertaining to a category, or you can drill down into a category and see all the statements pertaining to a maturity level.',
  howToUseParagraph3:
    'For best results, we recommend going through the evaluation tool with the support of your team or a Digital Competence specialist, who will be able to guide you through the more complex bits and give you insight.',
  howToUseAnalysingYourAssessment: 'Analysing your assessment',
  howToUseParagraph4:
    'The core feature of the website is a table where rows represent maturity categories, and columns represent maturity levels. On this overview, you can:',
  howToUseSeeASnapshot:
    'See a snapshot of your current progress and deep dive into single categories:',
  howToUseFilterTheResultsByDiveristy: 'Filter the results by thematic areas:',
  howToUseAssignMaturityGoals: 'Assign maturity goals for each category:',
  howToUseSaveYourProgress: 'Save your progress:',
  howToUseExportToPDF: 'Export your entire assessment as a PDF:',
  howToUseSavingAndExporting: 'Saving and exporting',
  howToUseParagraph5:
    'When saving, you are given a code to paste somewhere safe. Since this tool doesn’t collect any data by design, the only way to come back to your progress is by enteringentering the code on the homepage.',
  howToUseParagraph6:
    'If you export your progress as a PDF, you will find the code on the front page for easy copying and pasting.',
  howToUseParagraph7:
    'We designed the PDF export as a comprehensive Maturity Plan that you can use in meetings and workshops, when sitting down with you manager, or simply to doodle through it while planning your strategy. Keep in mind that it’s about 50 pages long and is generated in real time, so your browser might get a bit slow for 5 seconds.',
};
